import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { contentStyles, h3, h4, paragraphRegular, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
import { FakeButton } from '../Buttons/Button/Button';
const Container = styled.a `
  ${transition('opacity')};
  --cardBgColor: ${brand.global.white};
  --cardTextColor: ${brand.primary.blue};
  --iconBgSize: ${fluid(64, 96)};
  --iconSize: ${fluid(36, 52)};
  --gradStart: ${brand.primary.red};
  --gradEnd: ${brand.primary.blue};
  --cardPadding: ${fluid(24, 40)} ${fluid(24, 40)} ${fluid(20, 34)};

  display: flex;
  flex-direction: column;
  padding: var(--cardPadding);
  box-shadow: ${brand.boxShadow.card};
  border-radius: ${fluid(16, 24)};
  text-decoration: none;
  background-color: var(--cardBgColor);
  color: var(--cardTextColor);

  &[data-index='1'] {
    --cardBgColor: ${brand.grey.light};
  }

  &[data-index='2'] {
    --cardBgColor: ${brand.primary.blue};
    --cardTextColor: ${brand.global.white};
  }

  &:not([data-index='0']):not([data-index='1']):not([data-index='2']) {
    --cardPadding: 24px 24px 20px;
  }
`;
const IconBlock = styled.div `
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: var(--iconBgSize);
  margin-bottom: 24px;

  ${Container}:not([data-index='0']):not([data-index='1']):not([data-index='2']) & {
    --iconBgSize: 64px;
    --iconSize: 36px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: var(--iconBgSize);
    height: var(--iconBgSize);
    background: linear-gradient(270.52deg, var(--gradStart) 14.99%, var(--gradEnd) 84.92%);
    border-radius: 100%;
    z-index: 0;

    ${Container}[data-index='2'] & {
      background: ${brand.global.white};
    }
  }
`;
const IconWrapper = styled.div `
  position: relative;
  width: var(--iconSize);
  height: var(--iconSize);
  background: ${brand.global.white};
  mask-image: ${(props) => `url(${props.$svgUrl})`};
  mask-repeat: no-repeat;
  margin-right: calc((var(--iconBgSize) - var(--iconSize)) / 2);
  z-index: 1;

  ${Container}[data-index='2'] & {
    background: linear-gradient(270.52deg, var(--gradStart) 14.99%, var(--gradEnd) 84.92%);
  }
`;
const Title = styled.h3 `
  ${h3};

  margin-top: auto;
  margin-bottom: 8px !important;

  ${Container}:not([data-index='0']):not([data-index='1']):not([data-index='2']) & {
    ${h4};
  }
`;
const Description = styled.div `
  ${contentStyles};

  p {
    ${paragraphRegular};

    ${Container}:not([data-index='0']):not([data-index='1']):not([data-index='2']) & {
      ${paragraphSmall};

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
const Cta = styled(FakeButton) `
  &[data-type='text-only'] {
    --colorPrimary: var(--cardTextColor);
  }

  margin-top: 20px;

  ${Container}:not([data-index='0']):not([data-index='1']):not([data-index='2']) & {
    margin-top: 6px;
  }
`;
export const ExploreTheForumCardStyles = {
    Container,
    Cta,
    Description,
    IconBlock,
    IconWrapper,
    Title,
};
